var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topLevel"},[_c('div',{staticClass:"button",class:{grey: !(_vm.match =='start' || _vm.match =='plus') }},[_c('my_button',{attrs:{"value":_vm.title},nativeOn:{"click":function($event){return _vm.jump($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }